module.exports = Promise.all([parcelRequire.load("btW7r"), parcelRequire.load("hB7AO")]).then(() => parcelRequire('eYxlk'));